/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Paper({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Paper.Outline {...props} /> : <Paper.Solid {...props} />;
}

Paper.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <svg
          width="18"
          height="element.6xl"
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.63843 13.3584C4.63843 12.9442 4.97421 12.6084 5.38843 12.6084H10.7884C11.2026 12.6084 11.5384 12.9442 11.5384 13.3584C11.5384 13.7726 11.2026 14.1084 10.7884 14.1084H5.38843C4.97421 14.1084 4.63843 13.7726 4.63843 13.3584Z"
            fill="currentColor"
          />
          <path
            d="M5.38745 8.85596C4.97324 8.85596 4.63745 9.19174 4.63745 9.60596C4.63745 10.0202 4.97324 10.356 5.38745 10.356H8.74345C9.15767 10.356 9.49345 10.0202 9.49345 9.60596C9.49345 9.19174 9.15767 8.85596 8.74345 8.85596H5.38745Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1083 0.0117477C11.0651 0.00402863 11.0207 0 10.9753 0C10.93 0 10.8855 0.00402863 10.8424 0.0117477H4.58631C2.09883 0.00298277 0.0597561 1.98595 0.00113701 4.47308L0.000928812 4.49075V15.1959C-0.0494009 17.719 1.95197 19.8084 4.47625 19.8646L4.49293 19.8647L4.51056 19.8649L4.53278 19.8651C4.54846 19.8652 4.57017 19.8653 4.59496 19.8647H12.5739C12.5841 19.8647 12.5942 19.8645 12.6043 19.8641C15.1014 19.7628 17.0693 17.7005 17.0529 15.2012V6.03775C17.0529 5.84413 16.9781 5.65802 16.844 5.51835L11.779 0.242347C11.6375 0.0950256 11.4421 0.0117477 11.2379 0.0117477H11.1083ZM13.5412 6.984C11.7079 6.97883 10.2253 5.49248 10.2253 3.659V1.51175H4.58204C2.91299 1.50533 1.54466 2.8336 1.50093 4.50006V15.2037L1.50075 15.2201C1.4638 16.9175 2.80804 18.3243 4.50451 18.3648L4.52367 18.3649L4.54508 18.3651L4.55724 18.3652L4.56075 18.3651C4.56881 18.3649 4.57687 18.3647 4.58493 18.3647H12.5579C14.2411 18.2888 15.565 16.8957 15.5529 15.2091L15.5529 15.2037L15.5529 6.984H13.5433L13.5412 6.984ZM11.7253 2.35244L14.7317 5.484H13.5445C12.5382 5.48066 11.7253 4.66521 11.7253 3.659V2.35244Z"
            fill="currentColor"
          />
        </svg>
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Paper.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M18.8088 9.521C18.3573 9.521 17.7592 9.511 17.0146 9.511C15.1987 9.511 13.7055 8.008 13.7055 6.175V2.959C13.7055 2.706 13.5036 2.5 13.253 2.5H7.96363C5.49517 2.5 3.5 4.526 3.5 7.009V17.784C3.5 20.389 5.59022 22.5 8.16958 22.5H16.0463C18.5058 22.5 20.5 20.487 20.5 18.002V9.971C20.5 9.717 20.299 9.512 20.0475 9.513C19.6247 9.516 19.1177 9.521 18.8088 9.521Z"
          className="icon-secondary"
        />
        <path
          opacity="0.4"
          d="M16.0842 3.06737C15.7852 2.75637 15.2632 2.97037 15.2632 3.40137V6.03837C15.2632 7.14437 16.1742 8.05437 17.2802 8.05437C17.9772 8.06237 18.9452 8.06437 19.7672 8.06237C20.1882 8.06137 20.4022 7.55837 20.1102 7.25437C19.0552 6.15737 17.1662 4.19137 16.0842 3.06737Z"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.97398 11.8874H12.359C12.77 11.8874 13.104 11.5544 13.104 11.1434C13.104 10.7324 12.77 10.3984 12.359 10.3984H8.97398C8.56298 10.3984 8.22998 10.7324 8.22998 11.1434C8.22998 11.5544 8.56298 11.8874 8.97398 11.8874ZM8.97408 16.8816H14.4181C14.8291 16.8816 15.1631 16.5486 15.1631 16.1376C15.1631 15.7266 14.8291 15.3926 14.4181 15.3926H8.97408C8.56308 15.3926 8.23008 15.7266 8.23008 16.1376C8.23008 16.5486 8.56308 16.8816 8.97408 16.8816Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
